export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="10" fill="#0D9488" />
    <path d="M12 29V18" stroke="#FFFFFF" strokeWidth="3.4" strokeLinecap="round" />
    <path d="M20 29V12" stroke="#FFFFFF" strokeWidth="3.4" strokeLinecap="round" />
    <path d="M28 29V21" stroke="#99F6E4" strokeWidth="3.4" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark />
    <span
      className={`text-lg font-extrabold tracking-tight ${
        dark ? "text-white" : "text-slate-900"
      }`}
    >
      Kalku<span className="text-teal-600">Bisnis</span>
    </span>
  </span>
);
